// extracted by mini-css-extract-plugin
module.exports = {"tweetButton":"DealView_tweetButton__DaRQY"};